import { Pipe, PipeTransform } from '@angular/core';

import { PhoneNumberUtil } from '../../utils/phone-number.util';

@Pipe({
    name: 'phone',
    standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
    /**
     * Transforms "something with 0XXXXXXXXX or 33XXXXXXXXX" to "something with 06 XX XX XX XX"
     *      Not Transforms "something with string"
     * @param {string} data Text to be filtered
     * @returns {string} Filtered text
     */
    public transform(data: string | null | undefined): string | null | undefined {
        return PhoneNumberUtil.getFormattedPhone(data);
    }
}
